<script>
import eventBus from '@utils/eventBus'

import StarsRating from '@components/stars-rating.vue'

import Resizable from '@src/mixins/resizable.js'
import Translatable from '@src/mixins/translatable.js'

export default {
  components: {
    StarsRating
  },
  mixins: [
    Resizable,
    Translatable
  ],
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  computed: {
    reviewCardTruncationLimit() {
      return this.desktopScreen ? 485 : 380
    }
  },
  data() {
    return {
      translationActive: false,
      reviewExpanded: false,
      isReplyOpened: false
    }
  },
  methods: {
    expand() {
      eventBus.$emit('collapseSlider')
      this.reviewExpanded = true

      // We need to synchronize the slides height
      this.$nextTick(() => {
        const bodyHeight = this.$refs.body.offsetHeight
        const reviews = document.querySelectorAll('.review-slide')
        reviews.forEach((el) => {
          el.querySelector('.review-body').style.height = `${bodyHeight}px`
        })
      })
    },
    collapse() {
      eventBus.$emit('collapseSlider')
    },
    openReply() {
      this.isReplyOpened = !this.isReplyOpened
    }
  },
  created() {
    eventBus.$on('collapseSlider', () => {
      this.reviewExpanded = false
      this.$nextTick(() => {
        const reviews = document.querySelectorAll('.review-slide')
        reviews.forEach(el => {
          el.querySelector('.review-body').style.removeProperty('height')
        })
      })
    })
  }
}
</script>

<template>
  <div class="card-container">
    <div class="title-container">
      <div class="title-name-container">
        <p class="title name">{{ review.name }}</p>
        <p class="title">{{ review.place }}</p>
      </div>
      <p class="title">{{ review.date | monthDDYY }}</p>
    </div>
    <div class="text-container">
      <div>
        <div class="text-title-container">
          <h4 class="review-title">{{ review.title }}</h4>
          <StarsRating class="rating" :rating="review.rating"/>
        </div>
        <span v-if="!reviewExpanded" class="review-text" :inner-html.prop="review.text | truncate(reviewCardTruncationLimit)">
        </span>
        <span v-else class="review-text" v-html="review.text">
        </span>
        <span
          v-if="review.text.length > reviewCardTruncationLimit && !reviewExpanded"
          class="more-btn"
          @click="expand"
        >
          {{ getTranslatedContent('REVIEWS_more') }}
        </span>
        <span
            v-else-if="review.text.length > reviewCardTruncationLimit && reviewExpanded"
            class="more-btn"
            @click="collapse"
        >
          {{ getTranslatedContent('REVIEWS_less') }}
        </span>
      </div>
      <div class="footer" :class="isReplyOpened && 'opened'">
        <div v-if="review.reply" class="reply">
          <p class="reply-title" @click="openReply">
            {{  isReplyOpened ? getTranslatedContent('REVIEWS_coolpass_reply') : getTranslatedContent('REVIEWS_see_coolpass_reply') }}
          </p>
          <p class="reply-text" v-if="isReplyOpened" v-html="review.reply">
          </p>
        </div>
        <div class="see-translation">
          <!-- {{  translationActive ? 'See Original' : 'See Translation' }} -->
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.footer {
  display: flex;
  align-items: flex-end;

  &.opened {
    flex-direction: column;
    margin-left: 26px;
  }
}

.review-text, .reply {
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: $black;
  // opacity: 0.8;
  word-wrap: break-word;
}

.reply {
  width: 100%;
  margin-top: 15px;
  margin-left: 26px;
}

.reply-title {
  font-family: Open Sans Semibold, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: $orange;
  text-transform: capitalize;
  cursor: pointer;
}

.reply-text {
  margin-top: 9px;
}

.text-title-container {
  display: flex;
  margin-bottom: 26px;
}

.review-title {
  font-family: Open Sans Bold, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 23px;
  text-transform: uppercase;
  color: $dark-blue;
  margin-right: 20px;
}

.more-btn {
  cursor: pointer;
  font-family: "Open Sans Semibold", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: $dark-blue;
}

.card-container {
  width: 100%;
  display: flex;
}

.title-container {
  font-family: Open Sans Semibold, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
  color: $gray;
  width: 166px;
  margin-right: 24px;
}

.text-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.title {
  margin-bottom: 10px;

  &.name {
    font-family: Open Sans Bold, sans-serif;
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    color: $dark-blue;
  }
}

.status {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-style: normal;
  font-size: 16px;
  line-height: 21px;
  color: $dark-blue;
  margin-top: 3px;

}

.date {
  font-family: Open Sans Semibold, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
  color: $gray;
  margin-top: 10px;
}

.text {
  font-family: Open Sans Semibold, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
  color: $black;
}

.see-translation {
  cursor: pointer;
  min-width: 90px;
  margin-left: auto;
  font-family: Open Sans Semibold, sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: $dark-blue;
  margin-top: 11px;
}

.see-translation:hover {
  color: $gray;
}

.more-btn:hover {
  color: $orange;
}

@media only screen and (max-width: $screen-width-xs) {
  .card-container {
    flex-direction: column;
    padding-top: 20px;
    padding-bottom: 15px;
  }

  .title-name-container {
    display: flex;
    justify-content: space-between;
  }

  .text-title-container {
    flex-direction: column;
    margin-top: 15px;
    margin-bottom: 11px;
  }

  .title {
    margin-bottom: 5px;
  }

  .title-container {
    width: 100%;
  }

  .text {
    margin: 12px 0 22px;
    // opacity: 0.8;
  }

  .see-translation {
    margin-top: 10px;
  }

  .review-title {
    margin-bottom: 2px;
    font-size: 16px;
    line-height: 21px;
  }

  .reply {
    margin: 12px 0 11px 26px;
    margin-left: 0;
  }

  .footer {
    &.opened {
      margin-left: 0;
    }
  }
}
</style>
